<template>
  <el-carousel :interval="3000"  height="220">
    <el-carousel-item v-for="item in 1" :key="item">
<!--      <h3>{{ item }}</h3>-->
    </el-carousel-item>
  </el-carousel>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 220px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    /*background-color: #10bfba;*/
    background-image: url("../../assets/img/logo/xuyuan_bnaner.png");
  }

  .el-carousel__item:nth-child(2n+1) {
    /*background-color: #10bfba;*/
    background-image: url("../../assets/img/logo/xuyuan_bnaner.png");
  }
</style>



// WEBPACK FOOTER //
// src/components/banner/index.vue